import React from 'react';
import './TabSkip.scss';
import { HashLink as Link } from 'react-router-hash-link';

const TabSkip = () => {
  return (
    <div className="visually-hidden header-skip">
      <Link
        to='#main-content'
        tabIndex="0">
        Vai al contenuto della pagina
      </Link>
    </div>
  );
};

export default TabSkip;
